import {TabState, TabStateDefaults} from 'Navigation';

export default class AnalysisTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Analysis',
      closeable: false,
      preferenceKey: 'analysis',
    };
  }
}
